import IconExternalLink from 'asset/icon-external-link.svg'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { HeaderAction } from 'page/catalog/HeaderAction/HeaderAction'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const ShopButton = observer(() => {
  const demo = useDemo()
  const { shopUrl } = demo
  const { shopButton } = demo.product

  return <HeaderAction
    icon={<IconExternalLink />}
    label={shopButton || i18n('demo.ToTheFullSite')}
    href={shopUrl}
  />
})
